/**
 * Human labels for the `?window=` time axis.
 *
 * Lived as a private `WINDOW_LABEL` const in BOTH filter panels, identical in
 * each. The duplication was invisible because neither copy was exported, so a
 * fifth window added to `TimeWindow` would have widened the type, failed to
 * compile in two files, and been fixed in whichever one the author opened.
 */

import type { TimeWindow } from '@/hooks/mindspace/useTagFilters';

export const WINDOW_LABEL: Record<TimeWindow, string> = {
  today: 'Today',
  '7d': 'Last 7 days',
  '30d': 'Last 30 days',
  all: 'All time',
};
